<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('ShiftSchedule.schedulName')">
                    <el-input
                      size="mini"
                      v-model="formInline.schedulingName"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('ShiftSchedule.applicationShift')">
                    <el-select
                      v-model="formInline.shiftId"
                      :placeholder="$t('common.choseTip')"
                      filterable
                      size="mini"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in shiftList"
                        :key="item.id"
                        :label="item.shiftName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{$t('common.btn.search')}}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{$t('common.btn.cancel')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                v-if="isPrimaryKey('USERMANAGEMENT_EDIT')"
                  type="text"
                  @click="editShift"
                  :disabled="this.selected.length != 1"
                  >{{$t('common.btn.edit')}}</el-button
                >
                <el-button
                v-if="isPrimaryKey('USERMANAGEMENT_DELETE')"
                  type="text"
                  @click="deleteShift"
                  :disabled="this.selected.length != 1"
                  >{{$t('common.btn.delete')}}</el-button
                >
                <el-button v-if="isPrimaryKey('USERMANAGEMENT_ADD')" type="text" @click="addShift">{{$t('common.btn.add')}}</el-button
                >
                <!-- <i-column
                  :listData="columns"
                  @changeSort="changeSort"
                  ref="listSet"
                ></i-column> -->
              </div>
              <div class="rightAll-table">
                <el-table
                  :data="list"
                  height="500"
                  ref="carTable"
                  stripe
                  border
                  @selection-change="handleSelectionChange"
                  >
                  <el-table-column
                    type="selection"
                    width="40px;"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    type="index"
                    :label="$t('common.id')"
                    align="center"
                    :index="indexMethod"
                    width="80"
                  ></el-table-column>
                  <el-table-column
                    prop="schedulingName"
                    :label="$t('ShiftSchedule.schedulName')"
                    align="center"
                    width="200">
                  </el-table-column>
                  <el-table-column
                    prop="applicationShift"
                    :label="$t('ShiftSchedule.applicationShift')"
                    align="center"
                    width="300">
                  </el-table-column>
                  <el-table-column
                    prop="assertDate"
                    align="center"
                    :label="$t('ShiftSchedule.applicationDate')">
                    <template slot-scope="scope">
                      <div style="display:flex;justify-content: space-between;position: relative;">
                        <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                          <span>{{ scope.row.assertDate }}</span>
                        </div>
                        <el-button style="margin-left:10px;cursor: pointer;text-align: right;">{{ $t('ScheduleApplication.more') }}</el-button>
                      </div>
                      <div class="scheduleDate" style="position: absolute;right: 0;top: 0;opacity: 0;cursor: pointer;">
                        <el-date-picker
                          :value="scope.row.assertDate ? scope.row.assertDate.split(',') : []"
                          type="dates"
                          :editable="false"
                          :clearable="false"
                          value-format="yyyy-MM-dd"
                          style="width: 100%;height: 30px;cursor: pointer;">
                        </el-date-picker>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="applicationCar"
                    :label="$t('ShiftSchedule.applicationVehicles')"
                    align="center"
                    >
                    <template slot-scope="scope">
                      <div style="display:flex;justify-content: space-between;position: relative;">
                        <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                          <span>{{ scope.row.applicationCar }}</span>
                        </div>
                        <el-button style="margin-left:10px;width: 60px;text-align: right;">{{ $t('ScheduleApplication.more') }}</el-button>
                      </div>
                      <el-popover width="600" trigger="click" placement="bottom">
                        <div style="height: 300px;">
                          <el-scrollbar>
                            <el-row>
                              <div v-for="(item,index) in scope.row.carList" :key="index">
                                <el-col :span="6">{{item.carId}}</el-col>
                              </div>
                            </el-row>
                          </el-scrollbar>
                        </div>
                        
                        <div slot="reference" class="name-wrapper" style="position: absolute;right: 0;top: 0;opacity: 0;width: 60px;height: 35px;">
                          <el-button style="margin-left:10px;text-align: right;">更多</el-button>
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="applicationDriverName"
                    :label="$t('ShiftSchedule.applicationDriver')"
                    align="center"
                    >
                    <template slot-scope="scope">
                      <div style="display:flex;justify-content: space-between;position: relative;">
                        <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                          <span>{{ scope.row.applicationDriverName }}</span>
                        </div>
                        <el-button style="margin-left:10px;width: 60px;text-align: right;">{{ $t('ScheduleApplication.more') }}</el-button>
                      </div>
                      <el-popover width="600" trigger="click" placement="bottom">
                        <div style="height: 300px;">
                          <el-scrollbar>
                            <el-row>
                              <div v-for="(item,index) in scope.row.driverList" :key="index">
                                <el-col :span="6">{{item.name}}</el-col>
                              </div>
                            </el-row>
                          </el-scrollbar>
                        </div>
                        <div slot="reference" class="name-wrapper" style="position: absolute;right: 0;top: 0;opacity: 0;width: 60px;height: 35px;">
                          <el-button style="margin-left:10px;text-align: right;">更多</el-button>
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    :label="$t('ScheduleApplication.operation')"
                    align="center"
                    width="120">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="editRowShift(scope.row)">{{ $t('ScheduleApplication.edit') }}</el-button>
                      <el-button type="text" size="small" @click="deleteRowShift(scope.row)">{{ $t('ScheduleApplication.delete') }}</el-button>
                      <el-button @click="handleClick(scope.row)" type="text" size="small">{{ $t('ScheduleApplication.view') }}</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              >
            
              </i-table> -->
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="700px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="schedulingName"
            :label="$t('ShiftSchedule.schedulName')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              :disabled="isDisabled"
              size="small"
              v-model="form.schedulingName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="shiftId"
            :label="$t('ShiftSchedule.applicationShift')+':'"
            :label-width="formLabelWidth"
          >
            <el-select
              :disabled="isDisabled"
              v-model="form.shiftId"
              :placeholder="$t('common.choseTip')"
              filterable
              size="small"
            >
              <el-option
                v-for="item in shiftList"
                :key="item.id"
                :label="item.shiftName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="dateRange"
            :label="$t('ShiftSchedule.scheduleDateRange')+':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              :disabled="isDisabled"
              v-model="form.dateRange"
              type="daterange"
              :range-separator="$t('common.to')"
              :start-placeholder="$t('common.starDate')"
              :end-placeholder="$t('common.endDate')"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="handleRangeChange">
            </el-date-picker>
          </el-form-item>
          <el-form-item
            prop="assertDate"
            :label="$t('ShiftSchedule.effectiveDate')+':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              :disabled="isDisabled"
              v-model="form.assertDate"
              type="dates"
              :placeholder="$t('ScheduleApplication.clickEditSelectedDates')"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              style="width: 450px"
              @change="handleMultiChange">
            </el-date-picker>
          </el-form-item>
          <el-form-item
            prop="applicationCar"
            :label="$t('ShiftSchedule.PleaseSelectApplicationVehicleOrDriver')+':'"
            :label-width="formLabelWidth"
          >
            <scheduleTransfer ref="transfer" @car-change="carChange" @driver-change="driverChange"></scheduleTransfer>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" v-if="!isDisabled">
          <el-button size="small" @click="cancle('form')">{{$t('common.btn.cancel')}}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog>
      <!-- <el-dialog
        v-if="diaHidden"
        class="treeDialong"
        :title="$t('common.btn.roleData')"
        :visible.sync="dialogPowerVisible"
        width="520px"
        :before-close="handleClose"
        :close-on-click-modal="false"
      >
        <div>
          <div>
            <el-input
              size="small"
              :placeholder="$t('common.filterTip')"
              v-model="filterText"
            >
            </el-input>
            <div style="height: 380px">
              <el-scrollbar>
                <el-tree
                  :data="data"
                  show-checkbox
                  ref="tree"
                  node-key="label"
                  :check-on-click-node="false"
                  :default-expanded-keys="keyList"
                  :default-checked-keys="keyList"
                  :filter-node-method="filterNode"
                  :props="defaultProps"
                  :check-strictly="true"
                  @check="handCheck"
                  @check-change="checkChange"
                >
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="handleClose">{{$t('common.btn.cancel')}}</el-button
                >
            <el-button size="small" type="primary" @click="submit('form')"
              >{{$t('common.btn.confirm')}}</el-button>
          </span>
        </div>
      </el-dialog> -->
    </div>
  </div>
</template>

<script>
import ScheduleApplication from "./ScheduleApplication";
export default ScheduleApplication;
</script>

<style lang="less" scoped>
::v-deep .el-input__inner {
  cursor: pointer;
}
@import "../../../../assets/styles/Style.less";
</style>
